import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import optometry from "../../practices_images/optometry.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Optometry = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
      <h1>Optometry</h1>

      <div className="cap-section">
        <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting precision care at scale</h3>
            <p>
              Optometry practices deliver high volume, precision driven care that depends on accurate documentation, efficient workflows, and a consistent patient experience. Many practices manage a combination of routine exams, medical eye care, and optical services, each with distinct operational demands.
            </p>
            <p>
              We partner with optometry practices to help them operate efficiently while maintaining accuracy, compliance, and financial control.
            </p>
  
            <h3>The Operating Environment</h3>
            <p>
              Optometry clinics require reliable processes to support vision exams, corrective procedures, and eyewear prescriptions. Documentation must be precise, billing must align with vision and medical insurance requirements, and scheduling must support steady patient flow.
            <p>
            </p>
              When systems are not aligned, administrative burden increases and operational efficiency declines.
            </p>
  
            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help optometry practices strengthen the operational and financial processes that support consistent care delivery.
              </p>
              <p>
                Our work focuses on improving workflow efficiency, reinforcing documentation and coding accuracy, supporting reliable billing and reimbursement processes, and improving financial visibility across the practice.
              </p>
              <p>
                Our approach reflects the pace and structure of modern optometry care.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Enabling Consistency and Performance">
              <p>
                Our goal is to help practices operate with clarity and predictability.
              </p>
              <p>
                By reducing administrative friction and improving financial insight, we support better use of staff time, more reliable revenue, and a smoother experience for patients across clinical and optical services.
              </p>
              <p>
                This allows clinicians to remain focused on care while leadership maintains oversight.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Looking Ahead">
              <p>
                As demand for eye care continues to grow, strong operational foundations remain essential.
              </p>
              <p>
                We work with optometry practices to build the structure and discipline required to support long term success.
              </p>
              <p>
                Let’s begin a conversation about how your practice can move forward with confidence and purpose.
              </p>
            </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
          <img src={optometry} alt="Optometry" />
        </div>

      </div>
    </div>
  </motion.div>
  );
};

export default Optometry;
